// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AuthenticationGetCurrentUserDefaultResponse {
    static getAttributeTypeMap() {
        return AuthenticationGetCurrentUserDefaultResponse.attributeTypeMap;
    }
}
AuthenticationGetCurrentUserDefaultResponse.discriminator = undefined;
AuthenticationGetCurrentUserDefaultResponse.additionalProperties = false;
AuthenticationGetCurrentUserDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "ScriptsAuthenticationGetCurrentUserGetCurrentUserResponseModel"
    },
];
//# sourceMappingURL=authenticationGetCurrentUserDefaultResponse.js.map